import React from 'react';
import { compose, defaultProps, withHandlers } from 'recompose';
import Icon from 'components/Icon';
import withField from '../withField';
import cx from 'classnames';

import styles from './styles.css';

const Item = withHandlers<any, any>({
  onRemove:
    ({ index, onRemove }) =>
    () =>
      onRemove(index),
})(({ value, onRemove, hasError }: any) => (
  <div className={cx(styles.item, hasError && styles.error)}>
    <span className={styles.title}>{value}</span>
    <button onClick={onRemove} className={styles.remove}>
      <Icon name="close" className={styles.icon} width={17} height={17} />
    </button>
  </div>
));

export const Values = compose(
  defaultProps({ value: [] }),
  withHandlers({
    onRemove:
      ({ onChange, value }) =>
      (index) =>
        onChange(value.filter((_, i) => i !== index)),
  })
)(({ value, onRemove, error, getValue = (v) => v }: any) => (
  <div className={styles.root}>
    {value &&
      value.map((value, index) => (
        <Item
          key={value}
          hasError={error && error.includes(value)}
          index={index}
          value={getValue(value)}
          onRemove={onRemove}
        />
      ))}
  </div>
));

export default withField(Values);
